module.exports = __webpack_public_path__ + "img/page3.1a422cb8.png";